import React, { useState } from 'react';
import Card from '@/components/card';
import Title from '@/components/title';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { searchLocationCheckingReport } from '@/adapters/report';
import {
  ILocationCheckingReq,
  ILocationCheckingRes,
} from '@/interfaces/location';
import LocationCheckingTable from './_components/location-table';
import BusinessUnitSelector from '@/components/selector/business-unit-selector';
import { useAuth } from '@/contexts/AuthContext';

const _criteria: ILocationCheckingReq = {
  isLocationUpdate: false,
};

const Location = () => {
  const { userInfo } = useAuth();
  const [criteria, setCriteria] = useState<ILocationCheckingReq>({
    ..._criteria,
  });

  const { data: items, refetch } = useQuery<
    AxiosResponse<ILocationCheckingRes[]>,
    Error
  >({
    queryKey: ['search-location-checking', criteria],
    queryFn: async () => await searchLocationCheckingReport(criteria),
  });

  return (
    <>
      <Card>
        <Title title="Location Mapping " />
        <div className="flex flex-col gap-3">
          <div className="flex flex-col md:flex-row gap-3">
            <BusinessUnitSelector
              handleSelectData={function (id: number): void {
                setCriteria({ ...criteria, businessUnitId: id });
              }}
              disabled={!!userInfo?.bu}
            />
          </div>
          <LocationCheckingTable
            items={items?.data || []}
            onActioned={() => refetch()}
          />
        </div>
      </Card>
    </>
  );
};

export default Location;
